import Header from '@/components/index/Header';
import Footer from '@/components/index/Footer';
import styles from './index.module.scss';
export default () => {
  return (
    <div className={styles['deal-container']}>
      <Header />
      <div className={styles['deal-content']}>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>关于本政策</div>
          <p>
            当您访问丹家智选商城网站、使用基于云的服务或移动应用程序（统称为“站点”）时，我们可能会使用一个或多个跟踪工具，如cookies（任何形式）、标签、网络信标或像素（统称为“Cookies”）。本Cookie声明（“声明”）旨在向您简要介绍这些跟踪工具，解释我们如何使用它们，并为您提供不同的方式来管理与它们的互动以保护您的隐私。本声明不适用于丹纳赫中国生命科学平台未要求的第三方对您的个人信息的使用。“个人信息”是指可以直接或间接识别个人的任何信息，或可以合理预期与个人相关联的信息。这可以包括姓名、地址、电话号码、信用卡详情、电子邮件地址、身份证号码或其他识别码（即使没有其他识别信息）。有关我们如何处理您的个人信息的更多信息，请查看我们的隐私声明。
          </p>
        </div>
        <div className={styles['deal-item']}>
          <div className={styles['deal-title']}>理解Cookies及使用原因</div>
          <p>
            Cookies是存储在您的互联网设备上的小数据文件，例如您的电脑或手机，现在已成为大多数网站的标准。当您访问一个网站时，cookies允许该网站在您的浏览器中存储关于您的某些类型信息。当您稍后再次访问同一个网站时，浏览器中由cookies存储的相同信息将被发送回网站。Cookies被广泛用于网站运营，帮助网站更高效地运营，并为网站拥有者提供有关信息。它们执行许多不同的任务，例如让您在页面之间导航，记住您的偏好，改善您的用户体验。Cookies可能会收集个人信息（在某些司法管辖区中，这将包括您的互联网协议（IP）地址）。
            根据cookies所有者与cookies所在网站之间的关系，cookies可分为两大类。
            第一方Cookies：由您正在访问网站的所有者拥有，并由同一网站提供cookies。
            第三方Cookies：由不是网站所有者的其他人拥有，其他人应网站所有者的请求为您提供cookies。
            此外，cookies有多种类型。一般来说，大多数网站的cookies可以分为五类：
            必要Cookies：这些对于网站及任何所请求服务的提供是必不可少的，不执行任何其他或辅助功能。对于这些cookies，我们不会要求您的同意，但我们会通知您其存在于我们的网站上。我们的网站使用常规运营和安全，以及您所请求服务和产品提供的“绝对必要”的cookies。
            性能Cookies：这些提供统计信息和网站使用情况的分析。
            功能性Cookies：这些提供增强功能和个性化，如视频和实时聊天。它们可能由网站或我们页面上添加的第三方提供商设置。如果您不允许这些cookies，那么部分或全部增强功能可能无法正常使用。
            广告/定向Cookies：这些用于向您提供个性化内容。它们还可以用于创建个人资料。这些通常由第三方设置。
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};
